import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-enrollment-method",
    prompt: (guidanceItem) => getPrompt(guidanceItem),
    briefDescription: 'Enrollment Method',
    beforeLoad: async (component, guidanceItem) => {
        await component.$store.dispatch("employer/enrollment/getEmployerEnrollment", {employerId: guidanceItem.employerId});
    },
    openAction: { 
        text: "Where to review enrollment method?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Enrollment Information"
    },
    completeAction: {
    }
});

function getPrompt(item) {
    if (item.parameters.promptToSwitch == true) {
        return "We recommend selecting the portal based enrollment method. It allows you to renew existing participants with the same elections or quickly make updates to their elections without completing a spreadsheet. For more information on this method, click the ? icon in the right-hand side of this panel.";
    }
    else {
        return "We've selected the best enrollment method based on your employer information. Review the enrollment method currently selected. Click Save.";
    }
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-enrollment-method.js